import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAuthenticatedApi } from "../auth";

const buildUrl = (apiBaseUrl, standardId) => {
  const params = new URLSearchParams();
  if (standardId) params.set("StandardId", String(standardId));
  return `${apiBaseUrl}/api/v1/tracker/variations?${params.toString()}`;
};

/**
 * Fetches tracker variation data for a given standard.
 *
 * Returns:
 *   data.variationPendingChange  – Variation Pending Standards Change rows
 *   data.derogation              – Derogation rows
 *   data.temporaryVariation      – Temporary Variation rows
 */
const useTrackerVariations = ({
  standardId,
  enabled = true,
}) => {
  const { callProtectedApi, apiBaseUrl } = useAuthenticatedApi();

  const isEnabled =
    enabled &&
    Boolean(apiBaseUrl) &&
    Boolean(standardId);

  const { data, isLoading, error, isFetched } = useQuery({
    queryKey: ["trackerVariations", standardId],
    queryFn: async () => {
      const response = await callProtectedApi(
        buildUrl(apiBaseUrl, standardId),
        {},
      );

      return response?.data ?? {};
    },
    enabled: isEnabled,
    placeholderData: keepPreviousData,
    // staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    variationPendingChange: Array.isArray(data?.variationPendingChange)
      ? data.variationPendingChange
      : [],
    derogation: Array.isArray(data?.derogation) ? data.derogation : [],
    temporaryVariation: Array.isArray(data?.temporaryVariation)
      ? data.temporaryVariation
      : [],
    isLoading,
    isFetched,
    error,
  };
};

export default useTrackerVariations;
